<template>
  <div v-if="beautifyText" class="content">
    <pre
      >{{ beautifyText }}
    </pre>
  </div>
</template>

<script>
import beautifyJson from '@/utils/beautifyJson.js'

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    beautifyText() {
      if (!this.text) return

      return beautifyJson(this.text).trim()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin: 0 0 rem(20px) 0;
  font-size: rem(13px);
  color: $red;

  &:last-child {
    margin: 0;
  }

  pre {
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}
</style>
